import React from "react";
import TrafficSourceFilterSelections from "./TrafficSourceFilterSelections";
import TrafficSourceFilterActionButtons from "./TrafficSourceFilterActionButtons";
const TrafficSourceTableFilter = ({
  clearAllSelection,
  handleSearch,
  filterValuesLogic,
  loadingTrafficSources
}) => {
  const { selectionAddActions, filterValues } = filterValuesLogic;

  return (
    <div>
      <TrafficSourceFilterSelections
        selectionAddActions={selectionAddActions}
        filterValues={filterValues}
        handleSearch={handleSearch}
      />
      <TrafficSourceFilterActionButtons
        handleSearch={handleSearch}
        clearAllSelection={clearAllSelection}
        loadingData={loadingTrafficSources.isLoading}
      />
    </div>
  );
};

export default TrafficSourceTableFilter;
